<page-title text="Login | BitOasis" i18n-text="@@pageTitle.login"></page-title>
<site-layout class="narrow push">
  <h2 class="text-header text-bold text-center mb-2" i18n="@@front.login.title">Welcome back</h2>
  <p class="text-lg text-center" i18n="@@front.login.subtitle">Login into your BitOasis account</p>
  <div class="p-3"></div>

  <auth-login></auth-login>
</site-layout>
<site-footer></site-footer>
_